import { Component, Prop, Vue } from 'vue-property-decorator';
import { find, orderBy } from 'lodash';
import Job from '@/model/entity/job/job';
import JobTasks from '../job-tasks/index.vue';
import Techspec from '@/model/entity/job/techspec';
import draggable from 'vuedraggable';

@Component({
    components: {
        'app-job-tasks': JobTasks,
        draggable,
    },
})
export default class TechspecMilestones extends Vue
{
    @Prop({
        type: Object,
        default: null,
    })
    private techspec!: Techspec;

    private milestones: Job[] = [];
    private tasks: {[jobId: number]: Job[]} = {};

    private created()
    {
        this.loadJobs();
    }

    private _orderedMilestones: Job[] = [];
    private _orderedMilestonesDirty = true;

    /**
     * Returns the ordered milestones
     */

    private get orderedMilestones(): Job[]
    {
        // If the array is dirty, regenerate it
        if (typeof (this._orderedMilestonesDirty) === 'undefined' || this._orderedMilestonesDirty === true)
        {
            this._orderedMilestonesDirty = false;
            this._orderedMilestones = orderBy(this.milestones, [ 'order', 'dateCreated' ]);
        }

        return this._orderedMilestones;
    }

    /**
     * Updates the ordering of milestones
     */

    private set orderedMilestones(milestones: Job[])
    {
        if (!this.techspec.id)
        {
            return;
        }

        // Update the actual milestone's order
        const orders: {[key: number]: number} = {};
        let order = 1;

        for (const milestone of milestones)
        {
            if (!milestone.id)
            {
                continue;
            }

            const actualMilestone = find(this.milestones, { id: milestone.id });
            if (!actualMilestone)
            {
                continue;
            }

            actualMilestone.order = order;

            orders[milestone.id] = order;

            order++;
        }

        // Update the server
        this.$serviceContainer.techspecService.updateTechspecJobOrder(this.techspec.id, orders);

        // Mark the ordered milestones as being dirty
        this._orderedMilestonesDirty = true;
    }

    /**
     * Loads the jobs
     */

    private async loadJobs()
    {
        const results = await this.$serviceContainer.jobService.findJobs({
            techspec: this.techspec.id ?? undefined,
            itemsPerPage: 1000,
        });

        this.milestones = [];

        for (const job of results.results)
        {
            if (job.parentJob?.id)
            {
                if (!(job.parentJob.id in this.tasks))
                {
                    this.tasks[job.parentJob.id] = [];
                }

                this.tasks[job.parentJob.id].push(job);
            }
            else
            {
                this.milestones.push(job);
            }
        }

        // Mark the ordered milestones as being dirty
        this._orderedMilestonesDirty = true;
    }
}